// Mock pra demo de notificacao push (NotificacoesPedidoProvider).
// Substituido em producao por dados reais do backend.

export const FRETE_DISPONIVEL_MOCK = {
  id: 'FRT-001',
  pedidoId: 'PED-2001',
  origem: { nome: 'Nova Era Locações', endereco: 'Av. Brasil, 1500 - Aparecida', coords: { lat: -16.79, lng: -49.24 } },
  destino: { nome: 'Maria Santos', endereco: 'Rua das Flores, 123 - Setor Sul', coords: { lat: -16.68, lng: -49.26 } },
  distanciaTotal: 8.5,
  itens: [{ nome: 'Betoneira 400L', peso: 120, porte: 'pesado' }],
  pesoTotal: 120,
  valorFrete: 85,
  valorOriginal: 85,
  tempoEstimado: 25,
  status: 'aguardando',
};
